import ModalFactory from '../factory';

import Content from './AgentsListModal';

const AgentsListModal = ModalFactory(Content);

export default AgentsListModal;
